
import React from "react";
import { Container  , Col  ,Row  } from "reactstrap";
import Commonsection from './../component/UI/Common-section/Commonsection';
import  {useParams}   from  'react-router-dom';
import { NFT__DATA } from './../assets/data/data';
import Liveaction from './../component/UI/Live-Action/Liveaction';
import  '../Styles/nftDetails.css';
import { Link } from "react-router-dom";


function  NFTDetails( ){

    const {id} = useParams();

    const singleNft = NFT__DATA.find( item => item.id == id  )


    return(
        <>
            <Commonsection   title={singleNft.title}  />
            <section>
                <Container>
                    <Row>
                        <Col  lg="6" md="6"  sm="6" >
                            <img src={singleNft.imgUrl}   className="w-100  single__nft-img " />
                        </Col>

                        <Col lg="6"  md="6"  sm="6">
                            <div  className="single__nft__content">
                                <h2> {singleNft.title} </h2>

                                <div  className="d-flex   align-items-center  justify-content-between  mt-4  mb-4 " >
                                    <div  className="d-flex   align-items-center  gap-4   single__nft-seen  ">
                                        <span> 
                                            <i class="ri-eye-line"></i> 234  
                                        </span>
                                        
                                        <span> 
                                            <i class="ri-heart-3-fill"></i> 123 
                                        </span>
                                    </div>

                                    <div  className="d-flex   align-items-center  gap-2   single__nft-more  ">
                                        <span> 
                                            <i class="ri-send-plane-fill"></i>  
                                        </span>
                                        
                                        <span> 
                                            <i class="ri-more-2-line"></i> 
                                        </span>

                                    </div>
                                </div>

                                <div  className="nft__creator   d-flex  gap-3  align-items-center ">
                                    <div  className="creator__img">
                                        <img  className="w-100"  src={singleNft.creatorImg}  /> 
                                    </div>

                                    <div className="creator__details " >
                                        <p> Created By </p>
                                        <h6> {singleNft.creator} </h6>
                                    </div>
                                </div>


                                <p  className="my-4"> {singleNft.desc} </p>

                                <button  className="singleNft-btn  d-flex  align-items-center  gap-2  w-100  ">   
                                    <Link  to="/wallet"  className="gap-3 d-flex">
                                        <i class="ri-shopping-bag-line"></i> Place a Bid
                                    </Link> 
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Liveaction />


        </>
    );

}

export default NFTDetails;

